@let canCreateChannels = userContext.canCreateChannels();
@let canReadChannels = userContext.canReadChannels();
@let canUpdateChannels = userContext.canUpdateChannels();
@let canDeleteChannels = userContext.canDeleteChannels();

<div class="channel-page">
  <!-- New Channel Picker Section -->
  <div
    class="channel-title"
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <div
      fxLayout="row"
      fxLayoutAlign="start center">
      <img
        style="margin-right: 8px"
        src="/assets/images/satellite.svg" />
      <h3>{{ 'MANAGEMENT.COMMUNICATION-CENTER.CHANNELS' | translate }}</h3>
    </div>
    <div style="position: relative">
      @if (canReadChannels && canCreateChannels) {
        <input
          class="input is-small is-iconleft search-control"
          type="text"
          placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.SEARCH' | translate }}"
          [(ngModel)]="organizationChannelSearchText"
          (ngModelChange)="organizationChannelSearch()" />
        <i
          class="icon icon-search"
        style="position: absolute; top: 14px; left: 6px; color: var(--neutral-color-400)"></i>
      }
    </div>
  </div>

  @if (canCreateChannels) {
    <div class="channel-select">
      @for (channel of organizationChannels; track channel.channelUId) {
        <div
          class="channel-card">
          <div class="channel-type">{{ channel.channelTypeDisplay }}</div>
          <div class="channel-image"><img [src]="channel.logoImagePath" /></div>
          <div class="channel-button">
            <button
              (click)="selectChannel(channel)"
              class="button is-secondary is-small">
              {{ 'MANAGEMENT.COMMUNICATION-CENTER.ADD-CHANNEL' | translate }}
            </button>
          </div>
        </div>
      }
    </div>
  }

  @if (canReadChannels) {
    <!-- Configured Channels Section -->
    <topo-table
      [showHeader]="false"
      headerLabel="{{ 'MANAGEMENT.COMMUNICATION-CENTER.CHANNELS' | translate }}"
      [showNewItem]="false"
      [isLoading]="isLoading"
      searchPlaceholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.SEARCH-BY-NAME' | translate }}"
      itemName="{{ 'MANAGEMENT.DATAFEEDS.DATAFEED' | translate }}"
      [items]="configuredChannels"
      [queryParams]="queryParams$ | async"
      (paginate)="onPaginate($event)"
      (search)="onSearch($event)"
      (sort)="onSort($event)">
      <topo-columns>
        @if (canUpdateChannels || canDeleteChannels) {
          <topo-column
            label=""
            cellCssClass="is-actions">
            <ng-template let-channel="item">
              <topo-action-menu
                [item]="channel"
                location="right">
                @if (canUpdateChannels) {
                  <topo-action
                    [label]="'MANAGEMENT.COMMUNICATION-CENTER.EDIT' | translate"
                    icon="icon-edit"
                    (actionClick)="editClick(channel)" />
                }

                @if (canDeleteChannels) {
                  <topo-action
                    [label]="'MANAGEMENT.COMMUNICATION-CENTER.DELETE' | translate"
                    icon="icon-delete_trash"
                    (actionClick)="deleteClick(channel)" />
                }
              </topo-action-menu>
            </ng-template>
          </topo-column>
        }

        <topo-column
          label="{{ 'MANAGEMENT.COMMUNICATION-CENTER.COLUMN-NAME' | translate }}"
          sortField="Name">
          <ng-template let-channel="item">
            @if (canUpdateChannels) {
              <div
                class="table-row-select"
                (click)="editClick(channel)">
                {{ channel.name }}
              </div>
            } @else {
              <span [style]="{ fontWeight: 600, display: 'inline-block', padding: '0.5rem 0' }">{{ channel.name }}</span>
            }
          </ng-template>
        </topo-column>

        <topo-column
          label="{{ 'MANAGEMENT.COMMUNICATION-CENTER.COLUMN-TYPE' | translate }}"
          sortField="ChannelType">
          <ng-template let-channel="item">
            {{ channel.channelTypeDisplay }}
          </ng-template>
        </topo-column>

        <topo-column label="{{ 'MANAGEMENT.COMMUNICATION-CENTER.COLUMN-API' | translate }}">
          <ng-template let-channel="item">
            {{ channel.channelName }}
          </ng-template>
        </topo-column>

        <topo-column label="{{ 'MANAGEMENT.COMMUNICATION-CENTER.COLUMN-LAST-UPDATED' | translate }}">
          <ng-template let-channel="item">
            {{ channel.updatedOn | formatDate }}
          </ng-template>
        </topo-column>

        <topo-column label="{{ 'MANAGEMENT.COMMUNICATION-CENTER.COLUMN-ADDEDBY' | translate }}">
          <ng-template let-channel="item">
            <topo-avatar
              [name]="channel.lastEditedByName"
              [organizationUId]="organizationUId"
              [userProfileUId]="channel.lastEditedById"
            [showName]="true"></topo-avatar>
          </ng-template>
        </topo-column>

        <topo-column
          label="{{ 'MANAGEMENT.DATAFEEDS.IS-ACTIVE' | translate }}"
          sortField="IsActive">
          <ng-template let-channel="item">
            @if (canUpdateChannels) {
              <topo-switch
                [checked]="channel.isActive"
                (checkChanged)="isActiveClick(channel)" />
            } @else {
              <span class="ml-4">
                @if (channel.isActive) {
                  <i
                    class="icon icon-check_clear"
                  [style.fontWeight]="600"></i>
                } @else {
                  <i [style.fontWeight]="600">&mdash;</i>
                }
              </span>
            }
          </ng-template>
        </topo-column>
      </topo-columns>
    </topo-table>
    <topo-email-edit></topo-email-edit>
    <topo-sendgrid-email-edit></topo-sendgrid-email-edit>
    <topo-slack-edit></topo-slack-edit>
    <topo-everbridge-edit></topo-everbridge-edit>
    <topo-microsoft-teams-edit></topo-microsoft-teams-edit>
    <topo-twilio-edit></topo-twilio-edit>
    <topo-twilio-tts-edit></topo-twilio-tts-edit>
    <topo-whatsapp-edit></topo-whatsapp-edit>
    <horizon-sms-edit></horizon-sms-edit>
    <horizon-mobile-push-edit></horizon-mobile-push-edit>
    <gwts-mobile-edit></gwts-mobile-edit>
    <topo-confirm-delete
      [isActive]="!!channelToDelete"
    (confirmResponse)="confirmDeleteChannel($event)"></topo-confirm-delete>
  }
</div>
